// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1zcnX","productName":"Table_productName__1MskO"};